import { useSelector } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { readStates } from '@/constants/lifecycle';

const useRequestMarkdownActions = ({ category, code }) => useSelector(({
  auth: { role: { permissions: { requests: { read: allowRead } } } },
  requestMarkdown: { markdowns },
}) => {
  const { readStatus, text } = findResult(markdowns, category, code) || { text: '', ...readStates };
  return { allowRead, readStatus, text };
});

const useRequestMarkdownPanelAll = ({ category, code }) => useSelector(({
  auth: { role: { permissions: { requests: { read: canRead } } } },
  requestMarkdown: { markdowns },
}) => {
  const item = findResult(markdowns, category, code) || { text: '', name: '', ...readStates };

  return {
    canRead,
    name: item.name,
    readErrors: item.readErrors,
    readStatus: item.readStatus,
    text: item.text,
  };
});

export default {
  useRequestMarkdownActions,
  useRequestMarkdownPanelAll,
};
